import { ComponentType } from 'react';
import {
  TearSheetHeaderConfig,
  TearSheetCompanySummaryConfig,
  TearSheetInvestmentSummaryConfig,
  TearSheetPerformanceSummaryConfig,
  TearSheetCapitalizationSummaryConfig,
  TearSheetInvestmentThesisConfig,
  TearSheetPerformanceCommentaryConfig,
  TearSheetCompanyDescriptionConfig,
  TearSheetFinancingHistoryConfig,
} from '../TearSheetConfig';
import { TearsheetPanelType } from './types';

export const PANEL_CONFIG_COMPONENTS: Partial<
  Record<TearsheetPanelType, ComponentType<{ isInModal?: boolean }>>
> = {
  header: TearSheetHeaderConfig,
  companySummary: TearSheetCompanySummaryConfig,
  investmentThesis: TearSheetInvestmentThesisConfig,
  performanceCommentary: TearSheetPerformanceCommentaryConfig,
  companyDescription: TearSheetCompanyDescriptionConfig,
  investmentSummary: TearSheetInvestmentSummaryConfig,
  financingHistory: TearSheetFinancingHistoryConfig,
  performanceSummary: TearSheetPerformanceSummaryConfig,
  capitalizationSummary: TearSheetCapitalizationSummaryConfig,
};
